var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58337 9.49935C1.58337 6.51378 1.58337 5.02101 2.51087 4.09351C3.43837 3.16602 4.93114 3.16602 7.91671 3.16602H11.0834C14.0689 3.16602 15.5618 3.16602 16.4892 4.09351C17.4167 5.02101 17.4167 6.51378 17.4167 9.49935V11.0827C17.4167 14.0682 17.4167 15.5611 16.4892 16.4885C15.5618 17.416 14.0689 17.416 11.0834 17.416H7.91671C4.93114 17.416 3.43837 17.416 2.51087 16.4885C1.58337 15.5611 1.58337 14.0682 1.58337 11.0827V9.49935Z",
    stroke: "#8311B3",
    strokeWidth: 1.1875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.54163 3.16602V1.97852",
    stroke: "#8311B3",
    strokeWidth: 1.1875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.4584 3.16602V1.97852",
    stroke: "#8311B3",
    strokeWidth: 1.1875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.97913 7.125H17.0208",
    stroke: "#8311B3",
    strokeWidth: 1.1875,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.4577C14.25 13.8949 13.8955 14.2493 13.4583 14.2493C13.0211 14.2493 12.6666 13.8949 12.6666 13.4577C12.6666 13.0204 13.0211 12.666 13.4583 12.666C13.8955 12.666 14.25 13.0204 14.25 13.4577Z",
    fill: "#8311B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.2917C14.25 10.7289 13.8955 11.0833 13.4583 11.0833C13.0211 11.0833 12.6666 10.7289 12.6666 10.2917C12.6666 9.85443 13.0211 9.5 13.4583 9.5C13.8955 9.5 14.25 9.85443 14.25 10.2917Z",
    fill: "#8311B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 13.4577C10.2917 13.8949 9.93728 14.2493 9.50004 14.2493C9.0628 14.2493 8.70837 13.8949 8.70837 13.4577C8.70837 13.0204 9.0628 12.666 9.50004 12.666C9.93728 12.666 10.2917 13.0204 10.2917 13.4577Z",
    fill: "#8311B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 10.2917C10.2917 10.7289 9.93728 11.0833 9.50004 11.0833C9.0628 11.0833 8.70837 10.7289 8.70837 10.2917C8.70837 9.85443 9.0628 9.5 9.50004 9.5C9.93728 9.5 10.2917 9.85443 10.2917 10.2917Z",
    fill: "#8311B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 13.4577C6.33333 13.8949 5.97889 14.2493 5.54167 14.2493C5.10445 14.2493 4.75 13.8949 4.75 13.4577C4.75 13.0204 5.10445 12.666 5.54167 12.666C5.97889 12.666 6.33333 13.0204 6.33333 13.4577Z",
    fill: "#8311B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 10.2917C6.33333 10.7289 5.97889 11.0833 5.54167 11.0833C5.10445 11.0833 4.75 10.7289 4.75 10.2917C4.75 9.85443 5.10445 9.5 5.54167 9.5C5.97889 9.5 6.33333 9.85443 6.33333 10.2917Z",
    fill: "#8311B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCalendar);
export default __webpack_public_path__ + "static/media/eventCalendar.bc65aa16609dbef5f65a8986224809d7.svg";
export { ForwardRef as ReactComponent };